import styles from './GrandPrixLandingPage.module.css';
import { SiteLayout } from '@features/shared/ui/SiteLayout';
import { SiteLogoWidget } from '@features/shared/ui/SiteLogo/SiteLogoWidget';
import { UserSettingsMenuWidget } from '@features/user/ui/UserSettingsMenu/UserSettingsMenuWidget';
import { UserAuthMenuWidget } from '@features/user/ui/UserAuthMenu/UserAuthMenuWidget';
import { GrandPrixMainSection } from '@features/landing/grandprix/ui/sections/GrandPrixMainSection';
import { GrandPrixAnouncementSection } from '@features/landing/grandprix/ui/sections/GrandPrixAnouncementSection';
import { GrandPrixTournamentsSection } from '@features/landing/grandprix/ui/sections/GrandPrixTournamentsSection';
import { PremiumSection } from '@features/landing/shared/ui/sections/PremiumSection';
import { LeadersSection } from '@features/landing/grandprix/ui/sections/LeadersSection';
import { ChessOpenSection } from '@features/landing/shared/ui/sections/ChessOpenSection';
import { GrandPrixAdvantagesSection } from '@features/landing/grandprix/ui/sections/GrandPrixAdvantagesSection';
import { JuniorsSection } from '@features/landing/grandprix/ui/sections/JuniorsSection';
import { ActionsSection } from '@features/landing/shared/ui/sections/ActionsSection';
import { Loader } from '@ui/components/Loader';
import { GsapProvider } from '@features/landing/shared/providers/GsapProvider';
import { usePremiumLinksCtx } from '@features/landing/shared/providers/PremiumLinksProvider';
import { ActionsBg } from '@features/landing/shared/ui/components/ActionsBg';

export function GrandPrixLandingPage() {
  const { isLoading } = usePremiumLinksCtx();

  return (
    <GsapProvider>
      <SiteLayout
        preset="landing"
        siteLogo={<SiteLogoWidget />}
        actions={
          <>
            <UserSettingsMenuWidget />
            <UserAuthMenuWidget />
          </>
        }
      >
        <div className={styles.sections}>
          <GrandPrixMainSection />
          {isLoading ? (
            <div className={styles.loader}>
              <Loader centered />
            </div>
          ) : (
            <>
              <GrandPrixAnouncementSection />
              <GrandPrixTournamentsSection />
              <PremiumSection />
              <LeadersSection />
              <ChessOpenSection />
              <GrandPrixAdvantagesSection />
              <JuniorsSection />
              <ActionsSection />
            </>
          )}
        </div>
        {!isLoading && <ActionsBg />}
      </SiteLayout>
    </GsapProvider>
  );
}
